import React, { useState, useEffect } from 'react';
import { decodeHtml } from '../../../Cureus';

const NewDiscussionCard = ({discussion, currentUserId}) => {
  const [authors, setAuthors] = useState('')

  useEffect(() => {
    let authorList = discussion.author_list.split(',');
    if (authorList.length > 2) {
      const firstTwoAuthors = authorList.slice(0, 2).join(', ');
      const lastAuthor = authorList[authorList.length - 1];
      setAuthors(`${firstTwoAuthors}... ${lastAuthor}`);
    } else {
      setAuthors(authorList.join(', '));
    }
  }, [])

  const fireAmplitude = (eventType) => {
    $.ajax("/amplitudes", {
      dataType: "json",
      type: "POST",
      data: { 
              event_type: eventType, 
              user_id: currentUserId,
              article_id: discussion.article_id
            }
    })
  }

  const renderName = () => {
    if(discussion.commentatorQualis) {
      return (
        <div className='name-and-qualifications-container'>
          <p className="name">{discussion.commentatorName}</p>
          <p className="qualifications">{discussion.commentatorQualis}</p>
        </div>
      )
    } else {
      return (
        <p className="name">{discussion.commentatorName}</p>
      )
    }
  }
  
  return (
    <div className="join-discussion-card" href={discussion.resourcePath} onClick={() => fireAmplitude('discussionCardClicked')}>
      <div className="content-container">
        <div className="article-info-container">
          <div className="type-and-date-container">
            <div className="type">
              {discussion.type}
            </div>
            <div className="date">
              {discussion.date}
            </div>
          </div>
          <div className="title-container">
            <a
              className='title'
              href={discussion.resourcePath}
              onClick={() => fireAmplitude('discussionCardTitleClicked')}>{discussion.articleTitle}</a>
          </div>
        </div>
        <div className="article-activity-container">
          <div className="author-names-container">
            <div className="authors">
              {authors}
            </div>
          </div>
          <div className='comment-and-view-count-container'>
            <div className="comments">
              <img
                className='comments-icon'
                src="https://public.cureus.com/homepage_v2/comment.png"/>
              <span>{discussion.commentCount}</span>
            </div>
            <div className="views">
              <img
                className='eye-icon'
                src="https://public.cureus.com/homepage_v2/eye.png"/>
              <span>{discussion.viewsCount}</span>
            </div>
          </div>
          <a href={discussion.commentAnchorPath}>
            <div className="discussion-comment-container">
              <div className="profile-container">
                <img
                  className=''
                  src={discussion.avatar}/>
                {renderName()}
              </div>
              <div
                className="comment-body"
                dangerouslySetInnerHTML={{ __html: decodeHtml(discussion.body) }}/>
              <div className="join-discussion-container">
                <a
                  href={discussion.commentAnchorPath}
                  onClick={() => fireAmplitude('joinDiscussionClicked')}>JOIN DISCUSSION</a>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default NewDiscussionCard;